


























































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import {
  ConsumerAccountDetailsResource,
  ConsumerAccountDetails,
  Account,
} from '@/api/consumeraccountdetails';
import {
  Cycle, CycleResource,
} from '@/api/cycles';
import AccountDetailCard from '@/components/account/AccountDetailCard.vue';

interface AccountSummary {
  product: string;
  relationship: string;
  accountNumber: string;
  linkedAccount: string;
  accountKasasaKey: string;
  account: Account;
  expandDetails: boolean;
}

@Component({
  computed: mapState(['fiId']),
  components: {
    AccountDetailCard,
  },
})
export default class SpecificConsumerAccountDetails extends Vue {
  @Prop({ default: '' }) customerKasasaKey!: string;

  fiId!: string;

  loading: boolean = true;

  accountDetails: ConsumerAccountDetails | null = null;

  accountSummaryData: AccountSummary[] = [];

  cycles: Map<Number, Cycle> = new Map<Number, Cycle>();

  summaryHeaders: DataTableHeader[] = [
    { text: 'Product Name', value: 'product' },
    { text: 'Relationship', value: 'relationship' },
    { text: 'Account Number', value: 'accountNumber', width: '200px' },
    { text: 'Linked Account', value: 'linkedAccount' },
  ];

  @Inject('ConsumerAccountDetailsResource')
  consumerAccountDetailsResource!: ConsumerAccountDetailsResource;

  @Inject('CycleResource')
  cycleResource!: CycleResource;

  @Watch('customerKasasaKey')
  mounted() {
    this.loadData();
  }

  async loadData() {
    if (this.customerKasasaKey && this.fiId) {
      this.loading = true;
      await this.loadCycles();
      await this.loadConsumerAccountDetails();
      this.loading = false;
    }
  }

  async loadCycles() {
    this.cycles.clear();
    await this.cycleResource.getAllCycles(this.fiId).then((returnedCycles: Cycle[]) => {
      returnedCycles.forEach((cycle: Cycle) => {
        this.cycles.set(cycle.id, cycle);
      });
    }).catch((error: any) => {
      this.showErrorMessage(error);
    });
  }

  async loadConsumerAccountDetails() {
    await this.consumerAccountDetailsResource
      .getConsumerAccountDetails(this.fiId, this.customerKasasaKey)
      .then((result: ConsumerAccountDetails) => {
        this.accountDetails = result;
        this.buildAccountSummaryData();
      })
      .catch((error: any) => {
        this.showErrorMessage(error);
      });
  }

  buildAccountSummaryData() {
    this.accountSummaryData = [];
    if (this.accountDetails && this.accountDetails.accounts) {
      const that: SpecificConsumerAccountDetails = this;
      this.accountDetails.accounts.forEach((account: Account) => {
        const summary: AccountSummary = {
          product: account.fiProductName,
          relationship: that.getRelationshipForAccount(
            account.accountKasasaKey,
          ),
          accountNumber: account.coreAccountNumber,
          linkedAccount: this.getLinkedAccountColumnForAccount(account),
          accountKasasaKey: account.accountKasasaKey,
          account,
          expandDetails: false,
        };
        that.accountSummaryData.push(summary);
      });
    }
  }

  getLinkedAccountColumnForAccount(account: Account): string {
    let linkedAccountText: string = '-';

    if (account.linkedKasasaAccountType) {
      linkedAccountText = `${account.linkedCoreAccountNumber} (${account.linkedAccountFiProductName ? account.linkedAccountFiProductName : account.linkedKasasaAccountType})`;
    } else if (account.kasasaProductType === 'KASASA_SAVER') {
      const linkedAccount: Account | null = this.findAccountLinkedTo(account);
      if (linkedAccount) {
        linkedAccountText = `${linkedAccount.coreAccountNumber} (${linkedAccount.fiProductName})`;
      }
    }

    return linkedAccountText;
  }

  findAccountLinkedTo(linkedAccount: Account): Account | null {
    let parentAccount: Account | null = null;
    if (this.accountDetails && this.accountDetails.accounts) {
      for (let i = 0; i < this.accountDetails.accounts.length; i++) {
        if (
          this.accountDetails.accounts[i].linkedAccountKasasaKey === linkedAccount.accountKasasaKey
        ) {
          parentAccount = this.accountDetails.accounts[i];
          break;
        }
      }
    }
    return parentAccount;
  }

  getRelationshipForAccount(accountKasasaKey: string): string {
    let relationship: string = 'Unknown';
    if (this.accountDetails && this.accountDetails.relationships) {
      for (let i = 0; i < this.accountDetails.relationships.length; i++) {
        if (
          this.accountDetails.relationships[i].accountKasasaKey
          === accountKasasaKey
        ) {
          relationship = this.accountDetails.relationships[i]
            .relationshipClassification;
          break;
        }
      }
    }
    return relationship;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
